<template>
  <div class="w-full max-w-screen-lg" ref="slider">
    <app-slider
      :items="medias"
      :space-between="16"
      loop
      :breakpoints="{
        1024: { slidesPerView: 4 },
        768: { slidesPerView: 2 },
        640: { slidesPerView: 1 }
      }"
    >
      <template #slide="item">
        <div class="bg-white border-2 border-white" @click="storyDetail = item">
          <img :src="item.media_url" class="object-scale-down" />
          <div class="h-24 p-4 text-gray-600">
            <p
              class="line-clamp-2 text-sm text-left whitespace-pre-wrap"
              v-text="item.caption"
            />
            <p class="text-sm text-right">altro</p>
          </div>
        </div>
      </template>
    </app-slider>

    <transition name="fade">
      <div
        @wheel.stop
        v-if="hasDetail"
        class="lg:pt-6 bg-deepWater fixed inset-0 z-10 p-4 pb-12 overflow-hidden bg-opacity-75"
        @click="storyDetail = null"
      >
        <div
          @click.stop
          class=" relative flex flex-col max-w-xs max-h-full mx-auto overflow-hidden bg-white border-2 border-white shadow"
        >
          <div
            @click="storyDetail = null"
            class="top-1 right-1 bg-deepWater absolute text-white bg-opacity-75 rounded-full"
            :class="{ 'text-primary': light }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              class="w-8 h-8 cursor-pointer"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <div class="flex-1">
            <img :src="storyDetail.media_url" class="object-scale-down" />
          </div>
          <app-scrollable-box class="flex-1 p-4" dark>
            <p
              class="text-sm text-left text-gray-700 whitespace-pre-wrap"
              v-text="storyDetail.caption"
            />
          </app-scrollable-box>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  data: () => ({
    medias: undefined,
    storyDetail: null
  }),
  props: {
    igKey: String,
    pageId: String
  },
  computed: {
    prev() {
      return this.$refs.prev;
    },
    hasMedia() {
      return !_.isEmpty(this.medias);
    },
    hasDetail() {
      return !_.isEmpty(this.storyDetail);
    }
  },
  created() {
    this.getMedias();
  },
  methods: {
    async getMedias() {
      try {
        const medias = await this.axios.get(
          `https://graph.facebook.com/${this.pageId}/media?access_token=${this.igKey}`
        );
        let mediaList = [];
        for (const media of medias.data.data) {
          const mediaItem = await this.axios.get(
            `https://graph.facebook.com/${media.id}?access_token=${this.igKey}&fields=caption,media_url`
          );
          mediaList.push(mediaItem.data);
        }
        this.medias = mediaList;
      } catch (error) {
        return error;
      }
    }
  }
};
</script>

<style>
.swiper-container {
  margin: auto 1rem;
}
.vueperslides__track {
  height: fit-content;
}
.vueperslides--fixed-height {
  @apply h-full;
}
</style>
